export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7021.c0716e47.jpg";